interface FormCompletionStatus {
  isCompleted: boolean;
}

export type FormChecklistAutoAction = "complete" | "none";

export function getFormChecklistAutoAction(
  formStatuses: readonly FormCompletionStatus[],
  hasRequiredForms: boolean,
): FormChecklistAutoAction {
  if (formStatuses.length === 0) {
    return hasRequiredForms ? "none" : "complete";
  }

  return formStatuses.every((form) => form.isCompleted) ? "complete" : "none";
}
